// Colors are now fetched from the database via UserContext
// TextColorForColor remains a pure utility function

const hexToRGB = (hex: string) => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : {
        r: 0,
        g: 0,
        b: 0,
      };
};

export const TextColorForColor = (color: string) => {
  const rgb = hexToRGB(color);
  if (rgb.r * 0.299 + rgb.g * 0.587 + rgb.b * 0.114 > 186) {
    return '#000000';
  } else {
    return '#ffffff';
  }
};

export const LinkColorForColor = (color: string) => {
  const textColor = TextColorForColor(color);
  return textColor === '#ffffff' ? 'cyan.300' : 'blue.600';
};
